module.exports = __webpack_public_path__ + "img/solutions6.00c13db6.jpg";